//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "game-player",
    props: ['player', 'stats'],
    data() {
        return {
            modalWidth: '95%',
            modalIsOpen: false,
        }
    },
    mounted() {
        $('#game_player_' + this.player.player.id).remove();
        if(/Mobi|Android/i.test(navigator.userAgent) ) {
            this.modalWidth = '95%';
        } else {
            this.modalWidth = '60%';
        }
    },
    methods: {
        openStat() {
            this.modalIsOpen = true;
            setTimeout(() => {
                this.$modal.show('player-stats-' + this.player.player_id);
            }, 500);

        },

        closedModal() {
            console.log('closed');
            this.modalIsOpen = false;
        },

        close() {
            this.$modal.hide('player-stats-' + this.player.player_id);
            setTimeout(() => {
                this.modalIsOpen = false;
            }, 500);
        }
    },
}
